/**
 * AlmadarPostWhyWeStartedAlmadarSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWhyWeStartedAlmadarSLPostPage
 */

import { useAlmadarPostWhyWeStartedAlmadarSLPostPageLogic } from '@/hooks/traits/useAlmadarPostWhyWeStartedAlmadarSLPostPageLogic';
import type { AlmadarPostWhyWeStartedAlmadarSLPostPageConfig } from '@/hooks/traits/useAlmadarPostWhyWeStartedAlmadarSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWhyWeStartedAlmadarSLPostView as AlmadarPostWhyWeStartedAlmadarSLPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { AlmadarPostWhyWeStartedAlmadarSLPostHeaderView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarSLPostHeaderView';
import { AlmadarPostWhyWeStartedAlmadarSLPostView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarSLPostView';
import { AlmadarPostWhyWeStartedAlmadarSLPostFooterView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarSLPostFooterView';
import { Container } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWhyWeStartedAlmadarSLPostPageViewProps {
  config?: Partial<AlmadarPostWhyWeStartedAlmadarSLPostPageConfig>;
}

export function AlmadarPostWhyWeStartedAlmadarSLPostPageView({ config: propsConfig }: AlmadarPostWhyWeStartedAlmadarSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWhyWeStartedAlmadarSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWhyWeStartedAlmadarSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWhyWeStartedAlmadarSL" trait="AlmadarPostWhyWeStartedAlmadarSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWhyWeStartedAlmadarSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostWhyWeStartedAlmadarSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" paddingY="xl" fullWidth={true}><Container padding="lg" size="xl" maxWidth="xl"><AlmadarPostWhyWeStartedAlmadarSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWhyWeStartedAlmadarSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWhyWeStartedAlmadarSLPostPageView;
